import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, inject } from '@angular/core';
import { Snackbar } from '../snackbar/snackbar.service';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SensitiveClaimAccessComponent } from '../../components/layout/sensitive-claim-access.component';
import { DialogFocusService } from '../a11y/dialog-focus.service';

@Injectable()
export class ErrorHandlerService implements ErrorHandler {
  private snackbar = inject(Snackbar);
  private dialogService = inject(DialogService);
  private dialogFocus = inject(DialogFocusService);

  private sensitiveClaimDialogRef: DynamicDialogRef | undefined;

  handleError(error: unknown): void {
    console.error('Unhandled error:', error);
    if (error instanceof HttpErrorResponse) {
      if (error.status === 0 || error.status >= 500) {
        this.snackbar.show(
          'Something went wrong',
          'Error',
          'fa-light fa-circle-exclamation',
          2000,
        );
      } else if (error.status === 403) {
        if (error.error?.contactInfo) {
          this.sensitiveClaimDialogRef = this.dialogFocus.openWithFocus(
            this.dialogService,
            SensitiveClaimAccessComponent,
            {
              header: 'Sensitive Claim Access',
              width: '50rem',
              modal: true,
              inputValues: {
                info: error.error,
              },
            },
          );
        } else {
          this.snackbar.show(
            'Forbidden request',
            'Error',
            'fa-light fa-lock',
            2000,
          );
        }
      }
    }
  }

  public closeSensitiveClaimDialog(): void {
    if (this.sensitiveClaimDialogRef) {
      this.sensitiveClaimDialogRef.close();
      this.sensitiveClaimDialogRef = undefined;
    }
  }
}
